import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'moreDataToShow',
})
export class MoreDataToShowPipe implements PipeTransform {
  transform(data: any[], firstLinkNumberToShow: number): any[] {
    if (!data) {
      return [];
    }

    if (!firstLinkNumberToShow) {
      return data;
    }

    return data.slice(firstLinkNumberToShow);
  }
}
